import React from 'react'
import { Link } from 'react-router-dom'
import '../../Pages/pages.css'
import '../SchulteTable/SchulteTable.css'
import Navbar from '../../Components/Navbar'
import Button from '../../Components/Button'
export default class Home extends React.Component {
    render() {
        return (
            <>
                <header>
                    <Navbar />
                </header>
                <main className="main">
                    <div className="welcome-text"><h1>Welcome to Brain Booster !</h1></div>
                    <Link to="/schulteHome"><Button btn="outer-button" cls="home-button" number="Play Schulte Table"></Button></Link>
                    <Link to="/rememberIt"><Button btn="outer-button" cls="home-button" number="Play Remember It"></Button></Link>
                    <Link to="/mirrorImage"><Button btn="outer-button" cls="home-button" number="Play Mirror Image"></Button></Link>
                    <Link to="/statistics"><Button btn="outer-button" cls="home-button" number="Your Statistics"></Button></Link>
                </main>
            </>
        )
    }
}